<template>
    <div class="cs-userPrivateComponent cs-formBoxContainer" v-if="isUserPrivate">
        <DefaultHeader :offer="offer" @closeComponent="$emit('closeComponent')"></DefaultHeader>
        <div class="cs-userPrivateComponent__userInfo">
            <div class="cs-userPrivateComponent__userImageContainer">
                <img class="cs-userPrivateComponent__userImage" :src="user.profilePic" alt="user image">
            </div>
            <div class="cs-userPrivateComponent__userName">
                {{user.username}}
            </div>
            <div class="cs-userPrivateComponent__wrongUsernameQuestion" v-on:click="$emit('onWrongUsername')" >
                {{dictionary.wrongUsernameChangeIt}}
            </div>
        </div>

        <div class="cs-userPrivateComponent__lock"></div>

        <div class="cs-userPrivateComponent__userPrivateMessage">
            {{dictionary.userPrivateMessage}}
        </div>

        <div class="cs-userPrivateComponent__tryAgain cs-formSubmitButton cs-formSubmitButton--orange" v-on:click="$emit('retry', user.username)">
            {{dictionary.tryAgain}}
        </div>
        <div class="cs-userPrivateComponent__cancel cs-formSubmitButton cs-formSubmitButton--emptyRed" v-on:click="$emit('cancel')">
            {{dictionary.cancel}}
        </div>
    </div>
</template>

<script>
import DefaultHeader from './DefaultHeader.vue';
export default {
    name: 'UserPrivateComponent',
    props: ['isUserPrivate', 'offer', 'dictionary','user'],
    emits: ['closeComponent',"retry", "cancel", "onWrongUsername"],
    data() {
        return {}
    },
    components: {
        DefaultHeader
    }
}
</script>

<style  lang="scss" scoped>
@import '@/assets/scss/form.scss';

.cs-userPrivateComponent {
    &__user{
        &Info {
            display: grid;
            grid-template-columns: 0.5fr 1fr;
            column-gap: 20px;
        }

        &Image {
            width: 90px;
            border-radius: 25px;

            &Container {
                grid-row: 1 / span 2;
            }
        }

        &Name {
            color: #c98ce5;
            font-size: 18px;
            grid-column: 2;
            grid-row: 1;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        &PrivateMessage {
            font-size: 13px;
            font-weight: 500;
            text-align: center;
            color: #f15b65;
            margin: 15px 20px;
        }
    }

    &__wrongUsernameQuestion{
        font-size: 12px;
        color: #123f49;
        text-decoration: underline;
        cursor: pointer;
        grid-row: 2;
        grid-column: 2;
    }

    &__lock {
        width: 20px;
        height: 17px;
        border: 3px solid #ff5153;
        border-radius: 5px;
        position: relative;
        cursor: pointer;
        -webkit-transition: all 0.1s ease-in-out;
        transition: all 0.1s ease-in-out;
        animation-name: unlocked;
        animation-duration: 2s;
        animation-iteration-count: infinite;
        box-sizing: content-box;
        margin: 20px auto 0;

        &:after {
            content: "";
            display: block;
            background: #ff5153;
            width: 3px;
            height: 7px;
            position: absolute;
            top: 50%;
            left: 50%;
            margin: -3.5px 0 0 -2px;
            -webkit-transition: all 0.1s ease-in-out;
            transition: all 0.1s ease-in-out;
            animation-iteration-count: infinite;
            animation-name: unlockedAfter;
            animation-duration: 2s;
            box-sizing: content-box;
        }

        &:before {
            content: "";
            display: block;
            width: 10px;
            height: 10px;
            bottom: 100%;
            position: absolute;
            left: 50%;
            margin-left: -8px;
            border: 3px solid #ff5153;
            border-top-right-radius: 50%;
            border-top-left-radius: 50%;
            border-bottom: 0;
            -webkit-transition: all 0.1s ease-in-out;
            transition: all 0.1s ease-in-out;
            animation-name: unlockedBefore;
            animation-duration: 2s;
            animation-iteration-count: infinite;
            box-sizing: content-box;
        }

        &:hover:before {
            height: 12px;
        }
}
}

@keyframes unlocked {
    0% {}
    50% {
        transform: rotate(10deg);
        border: 3px solid #5ac3d6;
    }
    100% {
        transform: rotate(0deg);
        border: 3px solid #ff5153;
    }
}

@keyframes unlockedBefore {
    0% {}
    50% {
        bottom: 130%;
        left: 31%;
        margin-left: -11.5px;
        transform: rotate(-45deg);
        border: 3px solid #5ac3d6;
        border-bottom: 0;
    }
    100% {
        bottom: 100%;
        left: 50%;
        margin-left: -8px;
        transform: rotate(0deg);
        border: 3px solid #ff5153;
        border-bottom: 0;
    }
}

@keyframes unlockedAfter {
    0% {}
    50% {
        background: #5ac3d6;
    }
    100% {
        background: #ff5153;
    }
}
</style>